import React from "react";
import { useLang } from "../context/LangContext";
import useDocumentTitle from "../hooks/useDocumentTitle";
import InfoLayout from "../components/InfoLayout";
import SubmitForm from "../components/SubmitForm";

export default function ContactPage() {
  const { t } = useLang();
  useDocumentTitle(t("Contacto · ReiMultiBlog", "Contact · ReiMultiBlog"),
    t("Fala connosco através do formulário.", "Get in touch through the form."));
  return (
    <InfoLayout title={t("Contacto", "Contact")} crumb={t("Contacto", "Contact")}
      subtitle={t("Tens uma questão ou ideia? Escreve-nos pelo formulário abaixo.", "Have a question or idea? Write to us using the form below.")}>
      <p>{t("Preenche o formulário e respondemos assim que possível.", "Fill in the form and we'll get back to you as soon as possible.")}</p>
      <SubmitForm
        type="contact"
        showEmail emailRequired
        subjectLabel={t("Assunto", "Subject")}
        messageLabel={t("Mensagem", "Message")}
        subjectPlaceholder={t("ex.: Dúvida sobre seguros", "e.g. Question about insurance")}
        messagePlaceholder={t("Escreve aqui a tua mensagem…", "Write your message here…")}
        buttonLabel={t("Enviar mensagem", "Send message")}
      />
    </InfoLayout>
  );
}
